var React = require('react');

function ArrowGreyLightRight (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M1.017 23.91a.99.99 0 0 1-.733-.322.999.999 0 0 1 .061-1.407l11.12-10.22L.345 1.742A.999.999 0 0 1 .284.335.992.992 0 0 1 1.688.274l11.918 10.953a1 1 0 0 1 0 1.468L1.688 23.649a.989.989 0 0 1-.671.261z"}));
}

ArrowGreyLightRight.displayName = "ArrowGreyLightRight";

ArrowGreyLightRight.defaultProps = {"viewBox":"0 0 14 24"};

module.exports = ArrowGreyLightRight;

ArrowGreyLightRight.default = ArrowGreyLightRight;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-grey-light-right.svg
// module id = 1249
// module chunks = 0